import emailSpellChecker, { run } from "@zootools/email-spell-checker"

const ALLOWED_EMAIL_DOMAINS = ["mac.com.eg", "a15.com"];

export const isValidEmailSpelling = (email) => {
    const spellCheckValue = run({
        email,
        domains: [...emailSpellChecker.POPULAR_DOMAINS, ...ALLOWED_EMAIL_DOMAINS],
    });

    // if suggestions are available then its a typo
    return !Boolean(spellCheckValue);
}